import axios from 'axios'

type ApiSuccessOutput = { success: boolean } // this is not exported or passed into child components
type DefaultOutput = { message?: string } // optional, returned during an error and sometimes success

type IpTheftOutput = DefaultOutput & {
  case_num: string
  internal_id: string
}

export type BasicApiOutput = ApiSuccessOutput & DefaultOutput
export type PayloadType = IpTheftOutput | DefaultOutput
export type ApiPayloadType = PayloadType & BasicApiOutput

export async function submitForm(url: string, data: Record<string, string>) {
  return axios.post(url, data).then((response) => response.data)
}
